<template>
    <div class="brand-list">
      <div v-for="item of list" :key="item.cat_id" class="brand-list-item" @click="$emit('select', item)">
        <div class="brand-list-item-img">
          <img :src="item.cat_pic" />
        </div>
        <p>{{ item.cat_name }}</p>
      </div>
    </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style lang="scss" scoped>
  .brand-list {
    display: flex;
    flex-wrap: wrap;
    // margin: 0.1rem auto;
    font-size: 0.28rem;
    text-align: center;
    .brand-list-item{
      // flex: 3;
      margin: 0.2rem 0.13rem;
      height: fit-content;
    }
    .brand-list-item-img{
      width: 1.79rem;
      height: 1.78rem;
      padding: 0.2rem;
      border: 1px solid #CCCCCC;
      border-radius: 12px;
      
      img {
         width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
</style>